// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader_header__B0sh_","eyebrow":"SectionHeader_eyebrow__atYle","heading":"SectionHeader_heading__O85RJ","intro":"SectionHeader_intro__zJWfS"};